import { SlipExpiredError } from './errors';

export const STORAGE_KEY = 'wh-bet-slips';
export const STORAGE_EXPIRY_KEY = 'slip-expiry-timestamp';

export const setSlips = (slips, expireAt) => {
  if (expireAt) {
    localStorage.setItem(STORAGE_EXPIRY_KEY, expireAt);
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(slips));
};

export const clearSlips = () => {
  localStorage.removeItem(STORAGE_EXPIRY_KEY);
  localStorage.removeItem(STORAGE_KEY);
};

export const getSlips = () => {
  const expireAt = localStorage.getItem(STORAGE_EXPIRY_KEY);
  if (expireAt && Date.now() > expireAt) {
    clearSlips();
    throw new SlipExpiredError('Local storage data has expired');
  }
  return JSON.parse(localStorage.getItem(STORAGE_KEY));
};
